import { useIntl } from "react-intl";

import { wacToken } from "@/libraries/design/foundations";

import { Stats } from "../../../../libraries/design/patterns/stats/src/stats";

import type { StatsModuleProps } from "../../../../libraries/design/patterns/stats/src/stats";

type UniformStatsSectionProps = {
    title: string;
    primaryStatNumber: string;
    primaryStatDescription: string;
    primaryStatSymbolCharacter: string;
    secondaryStatNumber: string;
    secondaryStatDescription: string;
    secondaryStatSymbolCharacter: string;
    tertiaryStatNumber: string;
    tertiaryStatDescription: string;
    tertiaryStatSymbolCharacter: string;
};

export const UniformStatsSection = (props: UniformStatsSectionProps) => {
    const statsProps: StatsModuleProps = {
        headerText: props.title,
        bigStat: {
            stat: props.primaryStatNumber,
            statText: props.primaryStatDescription,
            statColor: wacToken("color.primary.blue"),
            statSymbol: {
                symbolCharacter: props.primaryStatSymbolCharacter,
                symbolCharacterColor: wacToken("color.primary.blue")
            }
        },
        littleStats: [
            {
                stat: props.secondaryStatNumber,
                statText: props.secondaryStatDescription,
                statColor: wacToken("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: props.secondaryStatSymbolCharacter,
                    symbolCharacterColor: wacToken("color.primary.blue")
                }
            },
            {
                stat: props.tertiaryStatNumber,
                statText: props.tertiaryStatDescription,
                statColor: wacToken("color.primary.blue"),
                statSymbol: {
                    symbolCharacter: props.tertiaryStatSymbolCharacter,
                    symbolCharacterColor: wacToken("color.primary.blue")
                }
            }
        ]
    };

    return <Stats {...statsProps} />;
};
